// Upsell "llega al despacho gratis" (snippets/cart-free-shipping-upsell.liquid).
// Se carga desde layout/theme.liquid y no con {% javascript %}: el cart drawer se renderiza por
// Section Rendering API y Shopify solo ejecuta el JS de los snippets presentes en el HTML inicial.
(function () {
  function track(name, data) {
    if (typeof window.gtag === 'function') window.gtag('event', name, data);
    if (window.posthog && typeof window.posthog.capture === 'function') window.posthog.capture(name, data);
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-fs-add]');
    if (!btn) return;
    const box = btn.closest('.fs-upsell');
    const msg = box.querySelector('[data-fs-error]');
    const eventData = {
      product_id: btn.dataset.fsProductId,
      variant_id: btn.dataset.fsAdd,
      product_title: btn.dataset.fsTitle,
      price: Number(btn.dataset.fsPrice),
      position: Number(btn.dataset.fsPosition),
      amount_left: Number(box.dataset.gap),
      location: box.dataset.location,
      currency: window.Shopify.currency?.active
    };
    track('free_shipping_upsell_click', eventData);
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    msg.textContent = '';
    try {
      const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(btn.dataset.fsAdd), quantity: 1 })
      });
      const data = await res.json();
      if (!res.ok) throw data;
      track('free_shipping_upsell_added', eventData);
      // Re-renderiza el carrito (drawer o /cart) y actualiza la barra FoxKit.
      await window.Shopify.onItemAdded(data);
    } catch (err) {
      track('free_shipping_upsell_error', { ...eventData, error: err.description || String(err.message || err) });
      msg.textContent = err.description || box.dataset.error;
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
    }
  });

  // En /cart el bloque vive fuera de .scd__body (al lado del resumen), así que renderNewCart no lo
  // reemplaza: se refresca aquí en cada cambio del carrito.
  // ponytail: un fetch extra de la sección por cambio, solo en /cart.
  if (window.MinimogSettings?.templateName === 'cart' && window.MinimogEvents) {
    window.MinimogEvents.subscribe('ON_CART_UPDATE', async () => {
      const slot = document.querySelector('[data-fs-upsell-slot]');
      if (!slot) return;
      const html = await fetch(window.location.pathname + '?section_id=cart-template').then((r) => r.text());
      const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-fs-upsell-slot]');
      if (next) slot.replaceWith(next);
    });
  }
})();
